import { useState } from 'react';
import { Col, Container, Nav, Row } from 'react-bootstrap';
import copyIcon from "../../assets/copy_icon.png";
import HeroDogImg from "../../assets/hero_dog_compress.png";
import './HeroSection.css';

const HeroSection = () => {
  const [copied, setCopied] = useState(false);
  const contractAddress = "FaKa2PCL3UgYpkYz7LAoab5AKrifGGfMZtumMCChpump";

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(contractAddress);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <section className='hero_section_main' id='home'>
      <Container>
        <Row className='align-items-center'>
          <Col md={6}>
            <div className='hero_section_left'>
              <div className="hero_section_titles">
                <h1>Samurai Dogg</h1>
                <h1>Born to Dominate</h1>
              </div>

              <div className='hero_section_btn'>
                <Nav.Link rel="noreferrer" target='_blank' href='https://www.mexc.com/en-GB/dex/trade?pair_ca=HWpJ9swetiCSWua5E5hKscdFL84NQ7DRKmSEgFDF7kDW&chain_id=100000&token_ca=FaKa2PCL3UgYpkYz7LAoab5AKrifGGfMZtumMCChpump&base_token_ca=So11111111111111111111111111111111111111112'>Buy Now</Nav.Link>
                <Nav.Link href="#followUs">Join Now</Nav.Link>
              </div>

              <div className='hero_section_token' onClick={handleCopy}>
                <p>{contractAddress}</p>
                <img src={copyIcon} alt='Copy to clipboard' />
                {copied && <span className="copied-tooltip">Copied!</span>}
              </div>
            </div>
          </Col>
          <Col md={6}>
            <div className='hero_section_right'>
              <img src={HeroDogImg} alt='HeroDogImg' />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default HeroSection